import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faCircle,
  faPlus,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import '../styling/todo-list.scss';

const ToDoList = () => {
  const [tasks, setTasks] = useState([
    { text: 'Ex. Book Plane Ticket', completed: false },
    { text: 'Ex. Book Hotels', completed: false },
    { text: 'Ex. Pack', completed: false },
  ]);

  const [newTask, setNewTask] = useState('');

  // Toggle task completion
  const toggleTask = (index) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].completed = !updatedTasks[index].completed;
    setTasks(updatedTasks);
  };

  // Delete a task
  const deleteTask = (index) => {
    const updatedTasks = tasks.filter((_, i) => i !== index);
    setTasks(updatedTasks);
  };

  // Add a new task
  const addTask = () => {
    if (newTask.trim() === '') return;
    setTasks([...tasks, { text: newTask, completed: false }]);
    setNewTask('');
  };

  return (
    <div className="todo-section">
      <h3>To Do List</h3>
      <ul className="todo-list">
        {tasks.map((task, index) => (
          <li key={index} className={`todo-item ${task.completed ? 'completed' : ''}`}>
            <FontAwesomeIcon
              icon={task.completed ? faCheckCircle : faCircle}
              className="check-icon"
              onClick={() => toggleTask(index)}
            />
            <span className="task-text">{task.text}</span>
            <FontAwesomeIcon
              icon={faTimes}
              className="delete-icon"
              onClick={() => deleteTask(index)}
            />
          </li>
        ))}
      </ul>

      {/* Add Task Input */}
      <div className="add-task">
        <FontAwesomeIcon icon={faPlus} className="plus-icon" />
        <input
          type="text"
          placeholder="Add Task"
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && addTask()}
        />
      </div>
    </div>
  );
};

export default ToDoList;
